<template lang="html">
  <div class="d-flex flex-column gap-2">
    <div style="max-height: calc(80vh - 100px); overflow-y: auto;">
      <div v-if="loading" class="list-item">
        <i class="fa fa-spinner fa-spin"></i>
        <span>&nbsp;Chargement</span>
      </div>
      <div v-for="msg in reports" :key="msg.uid" :class="{'read': msg.read}">
        <ImportReport :msg="msg"/>
      </div>
    </div>
    <BaseButton type="primary" outline icon="bi-plus" @click="loadMore" class="mx-auto">
      Afficher les rapports plus anciens

    </BaseButton>
  </div>
</template>


<script>
import IMPORTREPORT_SET from '@/gql/queries/importreportSet.graphql';
import { gqlQuery } from '@/gqlClient.js';
import ImportReport from '@/components/ImportReport';
import BaseButton from '@/components/ui/BaseButton.vue';

export default {
  name: "ImportReportList",
  components: { BaseButton, ImportReport },
  props: {},
  data() {
    return {
      loading: true,
      reports: []
    };
  },
  methods: {
    loadMore() {
      console.log("loadMore");
      gqlQuery(IMPORTREPORT_SET, { offset: this.reports.length }).then((data) => {
        if (data && data.body && data.body.data && data.body.data.importreport_set) {
          this.reports = this.reports.concat(data.body.data.importreport_set);
        }
      });
    }
  },
  mounted() {
    gqlQuery(IMPORTREPORT_SET, {}).then((data) => {
      this.loading = false;
      if (data && data.body && data.body.data && data.body.data.importreport_set) {
        this.reports = data.body.data.importreport_set;
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.list-header {
  padding: 10px;
  font-weight: bold;
}

.read {
  background: #EEE;
}
</style>
